export const useTemplatesPersistFilter = definePiniaStore(
  "templatesPersistFilter",
  {
    state: () => ({
      forMe: true,
      _showChangeTemplateStatusDrop: false,
    }),
    persist: true,
    actions: {
      setShowChangeLeadStatusDrop(value: boolean) {
        this._showChangeTemplateStatusDrop = value;
      },
    },
    getters: {
      showChangeTemplateStatusDrop: (state) =>
        state._showChangeTemplateStatusDrop,
    },
  },
);
